import React from 'react';
import { ComponentProps, Mode, MODE, Weight, WEIGHT } from './Heading.types';
import StyledHeading from './Heading.styled';

type ModeObject = { tag: string; fontSize: number; lineHeight: string };

const modeMap = new Map<Mode, ModeObject>([
  [MODE.DISPLAY, { tag: 'h1', fontSize: 8, lineHeight: '39px' }],
  [MODE.TITLE, { tag: 'h1', fontSize: 7, lineHeight: '34px' }],
  [MODE.HEADING, { tag: 'h2', fontSize: 6, lineHeight: '29px' }],
  [MODE.SUBHEADING, { tag: 'h3', fontSize: 5, lineHeight: '24px' }],
]);

const weightMap = new Map<Weight, number>([
  [WEIGHT.NORMAL, 400],
  [WEIGHT.BOLD, 700],
]);

const Heading: React.FC<ComponentProps> = ({ mode = 'heading', variant = 'primary', weight = 'normal', ...props }) => {
  const element = modeMap.get(mode);

  return (
    <StyledHeading
      {...props}
      as={element.tag}
      fontSize={element.fontSize}
      lineHeight={element.lineHeight}
      fontFamily={variant}
      fontWeight={weightMap.get(weight)}
      color="var(--color-indigo-t11)"
    />
  );
};

export default Heading;
